import React, { useCallback } from "react";
import { useRecoilValue } from "recoil";
import { BoardCellAtomFamily } from "../utils/context";
import { cssClasses } from "../utils/cssClasses";
export function Square(_a) {
    var location = _a.location, onSquareMouseEnter = _a.onSquareMouseEnter, onSquareMouseLeave = _a.onSquareMouseLeave;
    var cellState = useRecoilValue(BoardCellAtomFamily(location.index));
    var onMouseEnter = useCallback(function () {
        onSquareMouseEnter(location);
    }, [onSquareMouseEnter, location]);
    var onMouseLeave = useCallback(function () {
        onSquareMouseLeave(location);
    }, [onSquareMouseLeave, location]);
    return (React.createElement("div", { className: cssClasses("square", location.row > 0 && location.row % 5 === 0 && "border-top", location.col > 0 && location.col % 5 === 0 && "border-left") },
        React.createElement("div", { className: cssClasses("square-borders") },
            React.createElement("div", { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, className: cssClasses("inner-square", cellState) }))));
}
